/* eslint-disable */
/* Please refactor this file, I temporarily disabled lint on this file to remove the long warnings */
/* Warnings may cause errors or false positive bugs on javascript, lets avoid that */

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import appConfig from '../../../config';
import PatientList from '../../components/patient/Patient_list/PatientList';
import Modal from '../../commons/Modal/Modal';
import FloatingActionButton from '../../commons/Buttons/FloatingActionButton';
import SMSModal from '../../components/patient/SMSModal';
import { BootstrapSelect } from '../../commons/Inputs';

import {
    gotoNewPatient
} from '../../actions/redirect'

let $ = window.jQuery;
let App = window.App;

class Patients extends Component {
    static propTypes = {
        session: PropTypes.object.isRequired,
        gotoNewPatient: PropTypes.func.isRequired
    };

    state = {
        smsData: null,
        data : [],
        count : 0,
        dataSelected : [],
        isSaving : false,
        isDeleting : false,
        loadingState : false,
        singleData : [],
        loadingSpinner : false,
        filterBy : '',
        orderBy : '',
        procedures: [],
        filter_procedure: 0
    };

    getPatients = (e) => {
        let url = appConfig.apiUrl + 'dental/patients';
        axios({
            url: url,
            method: 'get',
            responseType: 'json'
        }).then((res) => {

            let displayData = res.data.data;
            // console.log(displayData);
            displayData.map((row, i) => {
                row.media_id = (row.user.media_id && parseInt(row.user.media_id, 10) !== 0) ? appConfig.staticFiles + row.user.media_id  : '/images/generic_profile_pic.png';

                row.name = row.user.firstname +' '+ row.user.lastname;
                row.entryDate = moment(row.created_at).format('MMM DD YYYY');
                row.user.user_addresses = '';
            });

            this.setState({
                data : displayData
            });

        }).catch(function (error) {
            console.log(error)
        });
    };

    getProcedures = () => {
        let url = `${appConfig.apiUrl}management/dental/procedures`;

        axios.get(url).then((res) => {

            let procedures = [
                {
                    value: 0,
                    label: 'Select Procedure...'
                }
            ];
            res.data.data.forEach((item, i) => {
                let tmp = {
                    value: item.id,
                    label: item.procedure
                };

                procedures.push(tmp);
            });

            this.setState({
                procedures
            });

            $('#filterProcedureId').selectpicker('refresh');
        });
    };

    showDeleteModal = (e) => {
        e.stopPropagation();

    };

    patientListLazyLoad = (offset, limit) => {

        this.setState({loadingSpinner : true}); //lazy load

        let url = appConfig.apiUrl + 'dental/patients?offset=' + offset + '&limit=' + limit + '&sort=' + this.state.filterBy + '&order=' + this.state.orderBy + '&procedure_id=' + this.state.filter_procedure;

        axios.get(url).then((res) => {
            let data = this.state.data;
            let sampleData = res.data.data;

            if(sampleData.length == 0)
            {
                this.setState({loadingSpinner : false}); //lazy load
            }

            sampleData.map((row) => {
                row.media_id = (row.user.media_id && parseInt(row.user.media_id, 10) !== 0) ? appConfig.staticFiles + row.user.media_id  : '/images/generic_profile_pic.png';

                row.name = row.user.firstname +' '+ row.user.lastname;
                row.entryDate = moment(row.created_at).format('MMM DD YYYY');
                data.push(row);
            });

            this.setState({
                data,
                loadingState : false,
                loadingSpinner : false //lazy load
            },() => {
                App.unblockUI();
            });
        }).catch((error) => {
            console.log(error);
        });
    };

    selectedCheckbox = (e,data) => {

        let selected = this.state.dataSelected;
        let count = selected.length;


        if(e.target.checked)
        {
            selected.push(data);
            count = selected.length;
        }else
        {
            selected.forEach((item, i) => {
                if(item.id == data.id)
                {
                    selected.splice(i, 1);
                }
            });
            count = selected.length;
        }

        this.setState({
            count,
            dataSelected : selected
        });

    };

    handleDeleteSelectedPatient = (e) => {
        let deleteData = this.state.dataSelected;
        let data = this.state.data;

        let patientIds = [];
        let url = appConfig.apiUrl + 'dental/patients/0';

        deleteData.forEach((deleted, i) => {

            patientIds.push(deleted.id);

            data.forEach((item, j) => {
                if(item.id === deleted.id)
                {
                    return data.splice(j,1);

                }
            })
        });

        let datas = {patientIds : patientIds};

        axios({
            url: url,
            method: 'delete',
            responseType: 'json',
            data : datas,
        }).then((response) => {
            console.log(response);
            this.setState({
                count : 0,
                dataSelected : [],
                data
            },() => {
                $('#deleteSelectedPatientModal').modal('hide');
            });
        }).catch(function (error) {
            console.log(error)
        });
    };

    singleDelete = (data) => {
        this.setState({singleData : data});
    };

    handleDeletePatient = () => {

        this.setState({isDeleting : true});

        let data = this.state.singleData;
        let patient = this.state.data;
        let url = appConfig.apiUrl + 'dental/patients/' + data.id;

        axios.delete(url).then((res) => {

            patient.forEach((item, i) => {
                if(item.id === data.id)
                {
                    return patient.splice(i,1);
                }
            });

            this.setState({
                data : patient,
                isDeleting : false
            }, () => {
                $('.modal').modal('hide');
            });

        }).catch((error) => {
            console.log(error);
        });
    };

    handleCloseModal = (e) => {

    };

    addNewPatient = () => {
        $('.tooltips').tooltip('hide');
        this.props.gotoNewPatient();
    };

    onFilter = (e) => {
        let val = e.target.value;
        let url = appConfig.apiUrl + 'dental/patients?sort=' + val + '&order=' + this.state.orderBy + '&procedure_id=' + this.state.filter_procedure;

        axios.get(url).then((res) => {
            let data = res.data.data;

            data.map((row) => {
                row.media_id = (row.user.media_id && parseInt(row.user.media_id, 10) !== 0) ? appConfig.staticFiles + row.user.media_id  : '/images/generic_profile_pic.png';
                row.branch = "";
                row.name = row.user.firstname +' '+ row.user.lastname;
                row.entryDate = moment(row.created_at).format('MMM DD YYYY');
            });

            this.setState({
                data,
                filterBy : val
            });

        }).catch((error) => {
            console.log(error);
        });

    };

    onOrder = (e) => {
        let val = e.target.value;
        let url = appConfig.apiUrl + 'dental/patients?sort=' + this.state.filterBy + '&order=' + val + '&procedure_id=' + this.state.filter_procedure;

        axios.get(url).then((res) => {
            let data = res.data.data;

            data.map((row) => {
                row.media_id = (row.user.media_id && parseInt(row.user.media_id, 10) !== 0) ? appConfig.staticFiles + row.user.media_id  : '/images/generic_profile_pic.png';
                row.branch = "";
                row.name = row.user.firstname +' '+ row.user.lastname;
                row.entryDate = moment(row.created_at).format('MMM DD YYYY');
            });

            this.setState({
                data,
                orderBy : val
            });

        }).catch((error) => {
            console.log(error);
        });

    };

    applyFilter = () => {
        let url = appConfig.apiUrl + 'dental/patients?sort=' + this.state.filterBy + '&order=' + this.state.orderBy + '&procedure_id=' + this.state.filter_procedure;

        axios.get(url).then((res) => {
            let data = res.data.data;

            data.map((row) => {
                row.media_id = (row.user.media_id && parseInt(row.user.media_id, 10) !== 0) ? appConfig.staticFiles + row.user.media_id  : '/images/generic_profile_pic.png';
                row.branch = "";
                row.name = row.user.firstname +' '+ row.user.lastname;
                row.entryDate = moment(row.created_at).format('MMM DD YYYY');
            });

            this.setState({
                data
            });

        }).catch((error) => {
            console.log(error);
        });

    };

    openSMSDialog = (data) => {
        this.setState({
            smsData: data
        }, () => {
            $('#smsModal').modal('show');
        });
    };

    handleFilterProcedure = (e) => {
        this.setState({
            filter_procedure: e.target.value
        }, () => {
            this.applyFilter();
        });
    };

    componentDidMount() {

        this.getPatients();
        this.getProcedures();

        $('.tooltips').tooltip();

        let offset = 6;
        let limit = 12;

        $(window).scroll(() => {
            if($(window).scrollTop() + $(window).height() == $(document).height()) {

                if($('#patientListContent').is(':visible')) {
                    this.patientListLazyLoad(offset,limit);
                    offset = offset + 12;
                }
            }
        });


    }

    render() {
        let datas = this.state.data;

        return(
            <div className="page-content">
                <div className="container-fluid" style={{marginBottom : '20px'}}>
                    <div className="col-md-12">
                        <div className="form-group form-md-line-input" style={{paddingTop : 0}}>
                            <label className="col-md-1 col-xs-3 control-label" htmlFor="patientSortField">Sort By:</label>
                            <div className="col-md-2 col-xs-9">
                                <select className="form-control" id="patientSortField" onChange={this.onFilter} style={{height : '30px'}} >
                                    <option value="">Select...</option>
                                    <option value="firstname">First Name</option>
                                    <option value="lastname">Last Name</option>
                                    <option value="last_visit">Last Visit</option>
                                    <option value="dentist_name">Dentist</option>
                                    <option value="branch_name">Branch</option>
                                    <option value="entry_date">Entry Date</option>
                                </select>
                                <div className="form-control-focus"> </div>
                            </div>
                            <div className="clearfix visible-xs-block"></div>
                            <label className="col-md-1 col-xs-3 control-label" htmlFor="patientOrderField">Order:</label>
                            <div className="col-md-2 col-xs-9">
                                <select className="form-control" id="patientOrderField" onChange={this.onOrder} style={{height : '30px'}} >
                                    <option value="ascending">Ascending</option>
                                    <option value="descending">Descending</option>
                                </select>
                                <div className="form-control-focus"> </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12" style={{ marginTop: '20px'}}>
                        <div className="col-md-1">Filters</div>

                        <div className="col-md-3">
                            <BootstrapSelect id="filterProcedureId" label="Procedure"
                                             help="Select procedure..."
                                             val={this.state.filter_procedure}
                                             onChange={this.handleFilterProcedure}
                                             options={this.state.procedures} />
                        </div>
                    </div>
                    {
                        this.state.count ?

                            <div className="col-md-12">
                                <span className="badge badge-info">{this.state.count}</span> Patients Selected
                                <a data-toggle="modal" data-target="#deleteSelectedPatientModal" style={{color : 'red',paddingLeft: '20px'}}>Delete Selected</a>
                            </div>

                            :

                            null
                    }
                </div>
                <div className="container-fluid" id="patientListContent">
                    {datas.map((item, i) => {
                        return <PatientList openSMSDialog={this.openSMSDialog} data={item} key={i} index={i} onCheckBox={this.selectedCheckbox} singleDeletePatient={this.singleDelete} />
                    })}
                </div>

                <div className="container-fluid text-center loadingSpinner" style={{paddingBottom: '30px',height : '22px'}}>
                    {
                        this.state.loadingSpinner ?

                            <img src="assets/global/img/loading-spinner-blue.gif" />

                            :

                            null
                    }
                </div>

                <Modal
                    id="deleteSelectedPatientModal"
                    header="DELETE"
                    onNegativeClickEvent={this.handleCloseModal}
                    onPositiveClickEvent={this.handleDeleteSelectedPatient}
                    positiveButton="Delete"
                    buttonBackgroundColor="btn red"
                    isSaving={this.state.isSaving}
                    width="320">

                    <div className="container-fluid">
                        <p>Are you sure you want to delete?</p>
                    </div>

                </Modal>

                <Modal
                    id="deletePatientModal"
                    header="DELETE"
                    onNegativeClickEvent={this.handleCloseModal}
                    onPositiveClickEvent={this.handleDeletePatient}
                    positiveButton="Delete"
                    buttonBackgroundColor="btn red"
                    isSaving={this.state.isDeleting}
                    loadingText="Deleting"
                    width="320">

                    <div className="container-fluid">
                        <p>Are you sure you want to delete?</p>
                    </div>

                </Modal>

                <div className="scroll-to-top">
                    <i className="icon-arrow-up" />
                </div>

                <SMSModal {...this.props} smsData={this.state.smsData} />

                <FloatingActionButton
                    title="Add new Patient"
                    onClick={this.addNewPatient} />
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    session: state.session
});

export default connect(mapStateToProps, {
    gotoNewPatient
})(Patients);


/** WEBPACK FOOTER **
 ** ./src/containers/Patients/index.js
 **/